import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import ImmersiveReaderSvg from 'assets/components/immersive_reader/immersive-reader-icon.svg'
import styles from './immersive_reader_button.scss'

class ImmersiveReaderButton extends PureComponent {

	render() {
		return (
			<button styleName='wrapper' onClick={this.props.onClickHandler}>
				<Isvg src={ImmersiveReaderSvg} styleName='icon' cacheGetRequests={true} />
			</button>
		)
	}
}

ImmersiveReaderButton.propTypes = {
	onClickHandler: PropTypes.func.isRequired,
}

export default CSSModules(
	ImmersiveReaderButton,
	styles,
	{ allowMultiple: true }
)
